import styled from 'styled-components'

export const ViewSettingToolbarContainer = styled.div`
    margin-bottom: 12px;
    padding: 0 5px;
    display: flex;
    flex-direction: column;
    gap: 8px;
`

export const ViewSettingToolbarContent = styled.div`
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
`

export const ViewSettingContainer = styled.div`
    display: flex;
    justify-content: flex-start;
`

export const ViewActionContainer = styled.div`
    max-width: 100%;
    flex: auto;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    align-items: center;
`

export const ViewSettingContent = styled.div`
    display: flex;
    flex: 1;
    flex-shrink: 0;
    flex-flow: row wrap;
    justify-content: flex-end;
`

export const ViewActionPositive = styled.div<{ isMobile?: boolean }>`
    display: flex;
    flex-shrink: 0;
    flex-flow: row wrap;
    gap: 8px;
    justify-content: flex-start;
    align-items: center;
    max-width: 100%;
    padding-right: ${({ isMobile }) => (isMobile ? 0 : '8px')};
    flex: ${({ isMobile }) => (isMobile ? 1 : 'none')};
`
